import { render } from "./PricingPageEditor.vue?vue&type=template&id=f2eb76bc&scoped=true"
import script from "./PricingPageEditor.vue?vue&type=script&lang=js"
export * from "./PricingPageEditor.vue?vue&type=script&lang=js"

import "./PricingPageEditor.vue?vue&type=style&index=0&id=f2eb76bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2eb76bc"]])

export default __exports__